<template>
  <div>
    <el-table :data="userList">
      <el-table-column prop="userId"  label="用户ID">
      </el-table-column>
      <el-table-column prop="time"  label="创建时间">
        <template slot-scope="scope">
          <span >{{ scope.row.time | moment}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="account"  label="账户">
        <template slot-scope="scope">
          <span >{{ scope.row.account }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type"  label="验证类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type=='1'">邮箱</span>
          <span v-else>短信</span>
        </template>
      </el-table-column>
      <el-table-column prop="content"  label="验证内容" width="600px">
        <template slot-scope="scope">
          <div v-if="scope.row.type=='1'" v-html="scope.row.content"></div>
          <span v-else>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      
      <!-- <el-table-column label="编辑" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
   
   
    <!-- 编辑用户信息dialog -->

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'

export default {
  name: 'UserList',
  data() {
    return {
      updateForm: {},
    }
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('userVerify', [
      'updateUserType',
      'updateDividendStatus',
      'updateMark',
      'allowTrade',
      'allowTransfer',
      'allowSwitchBin',
    ]),
    ...mapMutations('userVerify', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(selected) {
      this.updateForm = selected
      this.setUserinfoDetail(selected)
      this.setUserinfoDetailDialogVisible(true)
    },
  },
  computed: {
    // ...mapGetters('userVerify', ['userList']),
    ...mapState('userVerify', [
      'userList',
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: skyblue;
  font-weight: bold;
}
</style>
